import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthState } from '../../store/auth/auth.state';
@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  constructor(
    private store: Store,
    private router: Router
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.store.select(AuthState.getToken).pipe(      
      map(token => {
        
        if (token) {
          return true;
        }

        if (this.router.url.includes('reset-password')) {
          return true;
        }
        
        return this.router.createUrlTree(['/auth/login']);

      })
    );
  }

  canActivateChild(): Observable<boolean | UrlTree> {
    return this.canActivate();
  }
}
